import { useCallback } from 'react';

import { useSelector } from 'react-redux';

import { getAuthState } from '@/shared/authentication/slice/selectors';

import { isAuthorized, type AllowEntry } from './isAuthorized';

export function useAuthorize() {
  const role = useSelector(getAuthState);

  const checkAccess = useCallback(
    (allow: readonly AllowEntry[]): boolean => isAuthorized(role, allow),
    [role]
  );

  return { role, checkAccess } as const;
}
